import { LayoutModel } from '@paragon/contract-library';

import { ModelSchema } from './ModelSchema';
import { BuildingSchema, LevelSchema, ProjectSchema } from './schemas';

export function getSchemaForProjectHierarchyModel<T extends LayoutModel>(model: T): ModelSchema<T> {
  switch (model.type) {
    case 'project':
      return ProjectSchema;
    case 'building':
      return BuildingSchema;
    case 'level':
      return LevelSchema;
    default:
      throw new Error(`Unknown project hierarchy model type: ${model.type}`);
  }
}
